import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import PublishersGridlayout from './containers/Grid';

export default function PublisherLayout() {
  return (
    <Router>
      <PrivateRoute path="/offer/publishers" component={PublishersGridlayout} />
    </Router>
  );
}
